import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { User} from '../../models/data.types'

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './app-sidebar-header.component.html'
})
export class AppSidebarHeaderComponent { 
    user: User;
    isfavorite : boolean = false;
    showFavOnly : boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event) => {
            let currentRoute = this.route.root;
            this.user = JSON.parse(localStorage.getItem('currentUser'));
            if(localStorage.getItem('showFavOnly') != null)
            {
              this.showFavOnly =  JSON.parse(localStorage.getItem('showFavOnly'));
            }
            else
            {
              this.showFavOnly =  false;
            }
        });
    }

    toggleFavorite(){
        this.showFavOnly = !((Boolean)(JSON.parse(localStorage.getItem('showFavOnly'))));
        localStorage.setItem('showFavOnly',JSON.stringify(this.showFavOnly));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-header/app-sidebar-header.component.ts